import {
  PREMIUM_FEATURE_ADVANCED_MONITORING,
  PREMIUM_FEATURE_CREDIT_REPORT,
  PREMIUM_FEATURE_ID_THEFT_PROTECTION,
  PREMIUM_FEATURE_INSTANT_OFFERS,
  PREMIUM_FEATURE_LIVE_EXPERTS,
  PREMIUM_FEATURE_RENT_REPORTING,
  PREMIUM_FEATURE_WALLET_PROTECTION,
} from 'types/premium.constants';
import { emptyObj, isObj } from 'helpers/objectHelpers';
import { isEmpty } from 'helpers/string.helper';
import {
  ONEBUREAU_FREE_TRIAL,
  ONEBUREAU_FULL,
  THREEBUREAU_FREE_TRIAL,
  THREEBUREAU_FULL,
} from 'types/plus.constants';
import {
  CUSTOM_URL_BACK,
  HIDE_COMPLETELY,
} from 'partial/Header/PublicHeader.hook';

const hasConfig = config => {
  return !emptyObj(config);
};

export const getOptimizelyFeatureConfig = (feature, plusLandingFlag) => {
  const {
    scoresAndReportsModel,
    rentReportingModel,
    theftInsuranceModel,
    creditMonitoringModel,
    expertsAndDisputeModel,
    walletProtectionModel,
    instantOffersModel,
    mainJson,
  } = plusLandingFlag?.config ?? {};

  if (feature) {
    if (
      feature === PREMIUM_FEATURE_CREDIT_REPORT &&
      hasConfig(scoresAndReportsModel)
    ) {
      return scoresAndReportsModel;
    } else if (
      feature === PREMIUM_FEATURE_RENT_REPORTING &&
      hasConfig(rentReportingModel)
    ) {
      return rentReportingModel;
    } else if (
      feature === PREMIUM_FEATURE_ID_THEFT_PROTECTION &&
      hasConfig(theftInsuranceModel)
    ) {
      return theftInsuranceModel;
    } else if (
      feature === PREMIUM_FEATURE_ADVANCED_MONITORING &&
      hasConfig(creditMonitoringModel)
    ) {
      return creditMonitoringModel;
    } else if (
      feature === PREMIUM_FEATURE_LIVE_EXPERTS &&
      hasConfig(expertsAndDisputeModel)
    ) {
      return expertsAndDisputeModel;
    } else if (
      feature === PREMIUM_FEATURE_WALLET_PROTECTION &&
      hasConfig(walletProtectionModel)
    ) {
      return walletProtectionModel;
    } else if (
      feature === PREMIUM_FEATURE_INSTANT_OFFERS &&
      hasConfig(instantOffersModel)
    ) {
      return instantOffersModel;
    } else {
      return mainJson;
    }
  } else {
    return mainJson;
  }
};
export const getIsDefaultCouponFlow = (defaultCoupon, isTrialEligibleUser) => {
  return (
    isObj(defaultCoupon) &&
    !isEmpty(defaultCoupon?.couponCode) &&
    isTrialEligibleUser
  );
};

export const getIsTieredDefaultCouponFlow = (tieredLp, selectedBureauPlan) => {
  return (
    isObj(tieredLp?.defaultCoupon) &&
    !isEmpty(tieredLp?.defaultCoupon?.couponCode) &&
    (selectedBureauPlan === THREEBUREAU_FREE_TRIAL ||
      selectedBureauPlan === THREEBUREAU_FULL)
  );
};

export const getIsTieredDefaultCouponV2Flow = (
  tieredLp,
  selectedBureauPlan,
) => {
  if (
    isObj(tieredLp?.defaultCouponV2) &&
    !isEmpty(tieredLp?.defaultCouponV2?.couponCode)
  ) {
    if (
      tieredLp?.defaultCouponV2?.is3B &&
      (selectedBureauPlan === THREEBUREAU_FREE_TRIAL ||
        selectedBureauPlan === THREEBUREAU_FULL)
    ) {
      return true;
    }
    if (
      !tieredLp?.defaultCouponV2?.is3B &&
      (selectedBureauPlan === ONEBUREAU_FREE_TRIAL ||
        selectedBureauPlan === ONEBUREAU_FULL)
    ) {
      return true;
    }
    return false;
  }
  return false;
};

export const getFeatureNavigationUrl = featureNav => {
  if (featureNav === 'ScoresAndReportsModel') {
    return PREMIUM_FEATURE_CREDIT_REPORT;
  } else if (featureNav === 'RentReportingModel') {
    return PREMIUM_FEATURE_RENT_REPORTING;
  } else if (featureNav === 'TheftInsuranceModel') {
    return PREMIUM_FEATURE_ID_THEFT_PROTECTION;
  } else if (featureNav === 'CreditMonitoringModel') {
    return PREMIUM_FEATURE_ADVANCED_MONITORING;
  } else if (featureNav === 'ExpertsAndDisputeModel') {
    return PREMIUM_FEATURE_LIVE_EXPERTS;
  } else if (featureNav === 'WalletProtectionModel') {
    return PREMIUM_FEATURE_WALLET_PROTECTION;
  } else if (featureNav === 'InstantOffersModel') {
    return PREMIUM_FEATURE_INSTANT_OFFERS;
  }
};

export const getHeaderType = (isHybridCheckout, isActivatingSubscription) => {
  if (isHybridCheckout || isActivatingSubscription) {
    return HIDE_COMPLETELY;
  } else {
    return CUSTOM_URL_BACK;
  }
};

export const removeCarriageSymbols = payload => {
  if (!payload) return null;
  return payload.replace(/\|/g, '').replace(/\r/g, '').replace(/\n/g, '');
};
